import type { PracticeDepthMap } from "./depth-types";

/** Depth content: litigation, corporate, family, estate, property. */
export const PRACTICE_DEPTH_A: PracticeDepthMap = {
  litigation: {
    answer:
      "งานคดีความคือการที่ทนายความของสำนักงานรับผิดชอบเรื่องของท่านตั้งแต่ตรวจพยานหลักฐาน ประเมินอายุความ ร่างและยื่นคำฟ้องหรือคำให้การ ว่าความในชั้นศาล ไปจนถึงชั้นบังคับคดีเมื่อคำพิพากษาถึงที่สุด ทีมงานให้คำปรึกษาก่อนเริ่มงานเพื่อวางแนวทางที่เหมาะกับข้อเท็จจริงจริงของท่าน ค่าบริการประเมินเป็นรายเรื่องหลังดูเอกสาร",
    seoTitle: "คดีความและบังคับคดี — ทนายว่าความทุกศาลทั่วไทย",
    seoDesc:
      "งานว่าความแพ่ง อาญา แรงงาน ปกครอง และชั้นบังคับคดี: เอกสารที่ต้องเตรียม ขั้นตอนจริง ข้อควรระวังเรื่องอายุความ และคำถามที่พบบ่อย ปรึกษาทีมงานก่อนเริ่มเรื่อง",
    audience: [
      "ผู้ที่ถูกฟ้องหรือได้รับหมายศาลและยังไม่ทราบว่าต้องทำอะไรก่อน",
      "เจ้าหนี้ที่ทวงถามแล้วไม่ได้ผล และต้องพิจารณาฟ้องหรือบังคับคดี",
      "บริษัทที่มีข้อพิพาทตามสัญญากับคู่ค้าหรือลูกค้า",
      "ลูกจ้างหรือนายจ้างที่มีข้อพิพาทเข้าสู่ศาลแรงงาน",
      "ชาวต่างชาติที่มีคดีในประเทศไทยและต้องใช้ล่ามและเอกสารแปลรับรอง",
    ],
    compare: {
      heading: "เจรจา ไกล่เกลี่ย หรือฟ้องคดี — เลือกอย่างไร",
      intro:
        "สามทางนี้ไม่ได้แทนกันทั้งหมด หลายเรื่องเริ่มจากหนังสือทวงถามแล้วค่อยขยับไปขั้นถัดไปเมื่อไม่ได้ผล ตารางนี้ช่วยให้เห็นความต่างของภาระงานและผลผูกพัน",
      columns: ["เจรจา / หนังสือทวงถาม", "ไกล่เกลี่ยข้อพิพาท", "ฟ้องคดีต่อศาล"],
      rows: [
        {
          label: "ผลผูกพันทางกฎหมาย",
          cells: [
            "ผูกพันเมื่อทำบันทึกข้อตกลงที่ลงนามครบถ้วน",
            "บันทึกข้อตกลงที่ศาลหรือหน่วยงานรับรองใช้บังคับได้",
            "คำพิพากษาบังคับได้เมื่อถึงที่สุด",
          ],
        },
        {
          label: "ระยะเวลาโดยทั่วไป",
          cells: [
            "สั้นที่สุดในสามทาง ขึ้นกับความร่วมมือของอีกฝ่าย",
            "กลาง ขึ้นกับคิวนัดของหน่วยงานที่ไกล่เกลี่ย",
            "ยาวที่สุด มีนัดพิจารณาหลายนัดและอาจมีอุทธรณ์ฎีกา",
          ],
        },
        {
          label: "เอกสารที่ต้องใช้",
          cells: [
            "สัญญา หลักฐานการชำระ ประวัติการติดต่อ",
            "เอกสารเดียวกับการเจรจา บวกเอกสารแสดงตัวตนของผู้เข้าร่วม",
            "เอกสารครบชุดพร้อมพยานบุคคลและพยานเอกสารที่อ้างในคำฟ้อง",
          ],
        },
        {
          label: "เหมาะกับกรณี",
          cells: [
            "ยอดหนี้ชัดเจน อีกฝ่ายยังติดต่อได้",
            "ต้องการรักษาความสัมพันธ์ทางธุรกิจต่อไป",
            "อีกฝ่ายปฏิเสธความรับผิด หรืออายุความใกล้ครบ",
          ],
        },
        {
          label: "สิ่งที่มักถูกมองข้าม",
          cells: [
            "ไม่เก็บหลักฐานการทวงถามไว้เป็นลายลักษณ์อักษร",
            "ตกลงปากเปล่าแล้วไม่ทำบันทึก",
            "ฟ้องช้าจนขาดอายุความ หรือฟ้องผิดศาลที่มีเขตอำนาจ",
          ],
        },
      ],
      note: "ทุกกรณีขึ้นกับข้อเท็จจริงและเอกสารจริง ทีมงานจะประเมินให้หลังตรวจเอกสารก่อนเริ่มเรื่อง",
    },
    faqs: [
      {
        question: "ได้รับหมายศาลแล้วต้องทำอะไรก่อน",
        answer:
          "ดูวันนัดและกำหนดยื่นคำให้การในหมายเป็นอันดับแรก เพราะการไม่ยื่นภายในกำหนดอาจทำให้เสียโอกาสต่อสู้คดี รวบรวมสัญญา ใบเสร็จ และข้อความติดต่อทั้งหมด แล้วนำเอกสารพร้อมหมายเข้าปรึกษาทนายความก่อนถึงวันนัด",
      },
      {
        question: "อายุความสำคัญอย่างไรกับการฟ้อง",
        answer:
          "อายุความคือกรอบเวลาที่ใช้สิทธิเรียกร้องทางศาลได้ แต่ละมูลเหตุมีกำหนดต่างกันและเริ่มนับจากเหตุการณ์ต่างกัน เมื่อขาดอายุความอีกฝ่ายยกขึ้นต่อสู้ได้ ทีมงานจะตรวจวันเริ่มนับจากเอกสารจริงก่อนวางแนวทาง",
      },
      {
        question: "ต้องฟ้องที่ศาลไหน",
        answer:
          "ขึ้นกับประเภทคดีและเขตอำนาจ เช่น ข้อพิพาทตามสัญญาทั่วไป ข้อพิพาทระหว่างนายจ้างลูกจ้าง หรือคดีที่คู่กรณีเป็นหน่วยงานรัฐ จะอยู่คนละศาล การยื่นผิดศาลทำให้เสียเวลาและอาจต้องเริ่มใหม่ ทีมงานจะยืนยันเขตอำนาจจากภูมิลำเนาและสถานที่เกิดเหตุ",
      },
      {
        question: "ต้องมาศาลทุกนัดหรือไม่",
        answer:
          "ไม่ใช่ทุกนัด บางนัดเป็นเรื่องกระบวนพิจารณาที่ทนายความดำเนินการแทนได้ แต่นัดสืบพยานที่ท่านเป็นพยานเองต้องมาด้วยตนเอง ทีมงานจะแจ้งล่วงหน้าว่าแต่ละนัดต้องมีใครไปบ้าง",
      },
      {
        question: "หลักฐานเป็นแชตหรืออีเมลใช้ได้ไหม",
        answer:
          "ใช้อ้างเป็นพยานเอกสารได้ แต่ควรเก็บให้ครบบริบททั้งบทสนทนา ไม่ตัดเฉพาะบางข้อความ และเก็บข้อมูลที่แสดงว่าใครส่งเมื่อใด หากเป็นภาษาต่างประเทศจะต้องมีคำแปลที่รับรองความถูกต้องประกอบ",
      },
      {
        question: "ชนะคดีแล้วได้เงินทันทีหรือไม่",
        answer:
          "ไม่ทันที เมื่อคำพิพากษาถึงที่สุดและอีกฝ่ายไม่ชำระตามคำบังคับ ต้องเข้าสู่ชั้นบังคับคดี เช่น สืบทรัพย์ ยึดหรืออายัดทรัพย์ ซึ่งเป็นอีกขั้นตอนที่มีกำหนดเวลาและเอกสารของตัวเอง",
      },
      {
        question: "สืบทรัพย์คืออะไร",
        answer:
          "คือการตรวจหาทรัพย์สินของลูกหนี้ตามคำพิพากษาว่ามีอะไรที่ยึดหรืออายัดได้ เช่น บัญชีเงินฝาก ที่ดิน ยานพาหนะ หรือสิทธิเรียกร้อง หากไม่พบทรัพย์ การบังคับคดีจะทำได้ยากแม้ชนะคดีแล้ว",
      },
      {
        question: "ทำสัญญาไว้แต่ไม่ได้ปิดอากรแสตมป์ ฟ้องได้ไหม",
        answer:
          "ยังใช้เป็นหลักฐานได้ในหลายกรณี แต่บางกรณีมีผลต่อการรับฟังพยานเอกสารและมีภาระค่าอากรเพิ่ม ควรให้ทนายความตรวจสัญญาก่อนยื่นฟ้องเพื่อเตรียมประเด็นนี้ล่วงหน้า",
      },
      {
        question: "คู่กรณีอยู่ต่างประเทศจะฟ้องได้ไหม",
        answer:
          "ทำได้ในหลายกรณี แต่ขั้นตอนส่งหมายไปต่างประเทศใช้เวลามากกว่าปกติ และอาจต้องมีเอกสารแปลรับรองพร้อมนิติกรณ์ ทีมงานประสานงานแปลและรับรองเอกสารในสำนักงานเดียวกันได้",
      },
      {
        question: "ชาวต่างชาติที่ไม่พูดภาษาไทยต้องเตรียมอะไรเพิ่ม",
        answer:
          "ต้องเตรียมล่ามสำหรับนัดที่ต้องให้ถ้อยคำ และเอกสารภาษาต่างประเทศทุกฉบับต้องมีคำแปลที่รับรองความถูกต้อง หนังสือมอบอำนาจที่ทำจากต่างประเทศมักต้องผ่านการรับรองก่อนใช้ในไทย",
      },
      {
        question: "ถอนฟ้องหรือยอมความกลางทางได้หรือไม่",
        answer:
          "ได้ในหลายคดี และศาลมักสนับสนุนการตกลงกัน แต่ต้องทำเป็นสัญญาประนีประนอมยอมความที่ระบุเงื่อนไขการชำระให้ชัด เพื่อให้บังคับได้หากอีกฝ่ายผิดนัดในภายหลัง",
      },
      {
        question: "ต้องเตรียมค่าใช้จ่ายอะไรนอกจากค่าทนายความ",
        answer:
          "โดยทั่วไปมีค่าธรรมเนียมศาล ค่าส่งหมาย ค่าคัดถ่ายเอกสาร ค่าล่ามหรือค่าแปลหากมีเอกสารต่างประเทศ และค่าใช้จ่ายในชั้นบังคับคดีหากไปถึงขั้นนั้น ทีมงานจะสรุปรายการที่เกี่ยวกับเรื่องของท่านให้ก่อนเริ่มงาน",
      },
      {
        question: "ทำอย่างไรถ้ายังไม่แน่ใจว่าควรฟ้อง",
        answer:
          "เข้าปรึกษาก่อนโดยนำเอกสารเท่าที่มี ทีมงานจะประเมินความชัดของพยานหลักฐาน อายุความ และทางเลือกที่ไม่ต้องขึ้นศาล เพื่อให้ท่านตัดสินใจบนข้อมูลจริงก่อนผูกพันตัวเอง",
      },
    ],
    related: ["corporate", "labour", "property"],
    imageAlt: "ทนายความกำลังตรวจสำนวนคดีและพยานเอกสารร่วมกับทีมงานในห้องประชุมสำนักงาน",
  },

  corporate: {
    answer:
      "งานบริษัทและสัญญาครอบคลุมการจัดตั้งนิติบุคคล แก้ไขทะเบียนกรรมการและวัตถุประสงค์ ร่างและตรวจสัญญาธุรกิจ โครงสร้างการถือหุ้นสำหรับผู้ลงทุนต่างชาติ ไปจนถึงการซื้อขายกิจการและตรวจสอบสถานะทางกฎหมาย ทีมงานดูทั้งเอกสารจดทะเบียนและความเสี่ยงในสัญญาไปพร้อมกัน ค่าบริการประเมินเป็นรายเรื่อง",
    seoTitle: "กฎหมายธุรกิจ บริษัท และสัญญา — สำนักงานกฎหมายครบวงจร",
    seoDesc:
      "จัดตั้งบริษัท แก้ไขทะเบียน ร่างและตรวจสัญญา โครงสร้างผู้ลงทุนต่างชาติ ตรวจสอบสถานะกิจการ พร้อมเอกสาร ขั้นตอน ข้อควรระวัง และคำถามที่พบบ่อย",
    audience: [
      "ผู้เริ่มธุรกิจที่ต้องจัดตั้งบริษัทและวางเอกสารตั้งต้นให้ถูกต้อง",
      "บริษัทที่ต้องแก้ไขกรรมการ ที่ตั้ง หรือวัตถุประสงค์ในทะเบียน",
      "ผู้ลงทุนต่างชาติที่ต้องตรวจข้อจำกัดการประกอบธุรกิจก่อนลงทุน",
      "ผู้ที่กำลังจะเซ็นสัญญาสำคัญและต้องการให้ตรวจก่อนลงนาม",
      "ผู้ซื้อหรือผู้ขายกิจการที่ต้องทำตรวจสอบสถานะทางกฎหมาย",
    ],
    compare: {
      heading: "รูปแบบการทำธุรกิจในไทย — เปรียบเทียบให้เห็นภาระงานจริง",
      intro:
        "การเลือกรูปแบบมีผลต่อเอกสารจดทะเบียน ภาระบัญชี และความยืดหยุ่นในการรับผู้ลงทุนภายหลัง ตารางนี้เทียบสามรูปแบบที่พบบ่อยที่สุด",
      columns: ["บุคคลธรรมดา / ทะเบียนพาณิชย์", "ห้างหุ้นส่วนจดทะเบียน", "บริษัทจำกัด"],
      rows: [
        {
          label: "ความรับผิดของเจ้าของ",
          cells: ["รับผิดไม่จำกัดด้วยทรัพย์สินส่วนตัว", "ขึ้นกับประเภทหุ้นส่วน มีทั้งจำกัดและไม่จำกัด", "ผู้ถือหุ้นรับผิดจำกัดตามมูลค่าหุ้นที่ยังชำระไม่ครบ"],
        },
        {
          label: "เอกสารตั้งต้น",
          cells: ["น้อยที่สุด", "สัญญาจัดตั้งห้างและคำขอจดทะเบียน", "หนังสือรับรอง ข้อบังคับ บัญชีรายชื่อผู้ถือหุ้น รายงานการประชุม"],
        },
        {
          label: "ภาระบัญชีและงบการเงิน",
          cells: ["เบาที่สุด", "ต้องจัดทำและนำส่งงบการเงิน", "ต้องจัดทำงบ มีผู้สอบบัญชี และประชุมสามัญผู้ถือหุ้นทุกปี"],
        },
        {
          label: "การรับผู้ลงทุนเพิ่ม",
          cells: ["ทำได้ยาก", "ทำได้แต่ต้องแก้ไขสัญญาจัดตั้ง", "ยืดหยุ่นที่สุด โอนหุ้นและเพิ่มทุนได้"],
        },
        {
          label: "ข้อควรระวังที่พบบ่อย",
          cells: [
            "ใช้บัญชีส่วนตัวปนกับบัญชีธุรกิจ",
            "ไม่ระบุขอบเขตอำนาจของหุ้นส่วนผู้จัดการ",
            "วัตถุประสงค์ในทะเบียนไม่ครอบคลุมงานที่ทำจริง และไม่เก็บรายงานการประชุมให้ครบ",
          ],
        },
      ],
      note: "ผู้ลงทุนต่างชาติมีข้อพิจารณาเพิ่มเรื่องประเภทธุรกิจและสัดส่วนการถือหุ้น ควรตรวจก่อนยื่นจดทะเบียน",
    },
    faqs: [
      {
        question: "จัดตั้งบริษัทต้องเตรียมเอกสารอะไร",
        answer:
          "โดยทั่วไปต้องมีชื่อที่จองไว้แล้ว สำเนาบัตรประชาชนหรือหนังสือเดินทางของผู้เริ่มก่อการและกรรมการ ที่ตั้งสำนักงานพร้อมหลักฐานการใช้สถานที่ วัตถุประสงค์ที่ตรงกับงานจริง และโครงสร้างทุนกับรายชื่อผู้ถือหุ้น",
      },
      {
        question: "วัตถุประสงค์บริษัทควรเขียนกว้างหรือแคบ",
        answer:
          "ควรครอบคลุมงานที่ทำจริงและงานที่วางแผนจะทำในระยะใกล้ ถ้าแคบเกินไปจะติดปัญหาเวลาเปิดบัญชี ขอใบอนุญาต หรือเข้าประมูลงาน ถ้ากว้างเกินไปโดยไม่จำเป็นก็อาจถูกขอเอกสารเพิ่ม",
      },
      {
        question: "ชาวต่างชาติถือหุ้นในบริษัทไทยได้เท่าไร",
        answer:
          "ขึ้นกับประเภทธุรกิจ บางประเภทมีข้อจำกัดสัดส่วนการถือหุ้นของคนต่างชาติ บางประเภทต้องขออนุญาตหรือใช้ช่องทางส่งเสริมการลงทุน ทีมงานจะตรวจประเภทธุรกิจที่ท่านทำจริงก่อนวางโครงสร้าง",
      },
      {
        question: "การถือหุ้นแทนกันมีความเสี่ยงอย่างไร",
        answer:
          "การให้คนไทยถือหุ้นแทนคนต่างชาติเพื่อเลี่ยงข้อจำกัดมีความเสี่ยงทางกฎหมายทั้งต่อบริษัทและผู้ถือหุ้น สำนักงานไม่แนะนำแนวทางนี้ และจะช่วยหาโครงสร้างที่ทำได้จริงตามกฎหมายแทน",
      },
      {
        question: "เปลี่ยนกรรมการต้องทำอะไร",
        answer:
          "ต้องมีมติที่ประชุมตามข้อบังคับ จัดทำรายงานการประชุม และยื่นคำขอจดทะเบียนเปลี่ยนแปลงพร้อมเอกสารประจำตัวของกรรมการใหม่ หากมีการเปลี่ยนอำนาจลงนามต้องแก้ไขในทะเบียนด้วย",
      },
      {
        question: "สัญญาต้องทำเป็นภาษาไทยหรือไม่",
        answer:
          "ทำสองภาษาได้ และควรระบุให้ชัดว่าฉบับภาษาใดใช้บังคับเมื่อข้อความขัดกัน หากต้องยื่นต่อหน่วยงานราชการหรือใช้ในชั้นศาลไทย มักต้องมีคำแปลภาษาไทยที่รับรองความถูกต้องประกอบ",
      },
      {
        question: "ตรวจสัญญาก่อนเซ็นดูอะไรเป็นหลัก",
        answer:
          "ดูขอบเขตงานและเงื่อนไขการชำระเงิน การรับประกันและความรับผิด ข้อจำกัดความรับผิด เหตุเลิกสัญญา การรักษาความลับ สิทธิในทรัพย์สินทางปัญญา และกฎหมายที่ใช้บังคับกับช่องทางระงับข้อพิพาท",
      },
      {
        question: "ต้องประชุมผู้ถือหุ้นทุกปีจริงหรือ",
        answer:
          "บริษัทจำกัดต้องจัดประชุมสามัญผู้ถือหุ้นตามรอบที่กฎหมายกำหนดเพื่ออนุมัติงบการเงิน การไม่จัดหรือไม่เก็บรายงานการประชุมมักกลายเป็นปัญหาเมื่อต้องทำธุรกรรมสำคัญหรือขายกิจการภายหลัง",
      },
      {
        question: "หนังสือมอบอำนาจที่ทำจากต่างประเทศใช้ในไทยได้ไหม",
        answer:
          "ใช้ได้เมื่อผ่านขั้นตอนรับรองที่ถูกต้อง โดยทั่วไปต้องรับรองลายมือชื่อในประเทศต้นทาง แปลเป็นภาษาไทยพร้อมรับรองคำแปล และผ่านนิติกรณ์ตามช่องทางที่หน่วยงานผู้รับเอกสารกำหนด",
      },
      {
        question: "ตรวจสอบสถานะทางกฎหมายก่อนซื้อกิจการดูอะไร",
        answer:
          "ดูเอกสารจดทะเบียนและโครงสร้างผู้ถือหุ้น สัญญาสำคัญและข้อจำกัดการโอน ใบอนุญาตที่ใช้ประกอบกิจการ ภาระผูกพันและหลักประกัน ข้อพิพาทที่ค้างอยู่ สัญญาจ้างและภาระต่อลูกจ้าง รวมถึงสิทธิในทรัพย์สินทางปัญญา",
      },
      {
        question: "บริษัทที่ตั้งแล้วแต่ยังไม่มีรายได้ ต้องทำอะไรทุกปีไหม",
        answer:
          "ต้องจัดทำและนำส่งงบการเงินตามรอบบัญชีแม้ยังไม่มีรายได้ และยังมีหน้าที่ยื่นแบบตามที่กฎหมายกำหนด การปล่อยค้างมักทำให้มีเบี้ยปรับและเป็นอุปสรรคเวลาทำธุรกรรมภายหลัง",
      },
      {
        question: "จะให้สำนักงานดูแลตั้งแต่ต้นจนจบได้ไหม",
        answer:
          "ได้ ทีมงานรับดูแลตั้งแต่จองชื่อ จัดทำเอกสารจดทะเบียน ยื่นต่อหน่วยงาน ตรวจสัญญาชุดแรกที่ต้องใช้ ไปจนถึงประสานงานบัญชีและใบอนุญาตที่เกี่ยวข้อง ปรึกษาก่อนได้เพื่อประเมินเป็นรายเรื่อง",
      },
    ],
    related: ["tax", "labour", "ip"],
    imageAlt: "ทนายความอธิบายเงื่อนไขสัญญาธุรกิจให้ผู้บริหารในห้องประชุมสำนักงานกฎหมาย",
  },

  family: {
    answer:
      "งานครอบครัวของสำนักงานครอบคลุมการจดทะเบียนสมรสกับชาวต่างชาติและเอกสารที่ต้องใช้ประกอบ สัญญาก่อนสมรส การหย่าทั้งโดยความยินยอมและโดยคำพิพากษา อำนาจปกครองบุตรและค่าอุปการะเลี้ยงดู การรับรองบุตร และการรับบุตรบุญธรรม ทีมงานดูเอกสารทะเบียนราษฎรและเอกสารต่างประเทศไปพร้อมกัน",
    seoTitle: "กฎหมายครอบครัว — สมรส หย่า บุตร และเอกสารต่างชาติ",
    seoDesc:
      "จดทะเบียนสมรสกับชาวต่างชาติ สัญญาก่อนสมรส หย่า อำนาจปกครองบุตร ค่าอุปการะ รับรองบุตร และรับบุตรบุญธรรม พร้อมเอกสาร ขั้นตอน และข้อควรระวัง",
    audience: [
      "คู่สมรสไทยกับชาวต่างชาติที่ต้องเตรียมเอกสารจดทะเบียนสมรส",
      "ผู้ที่ต้องการทำสัญญาก่อนสมรสเพื่อกำหนดเรื่องทรัพย์สิน",
      "ผู้ที่ต้องการหย่าและตกลงเรื่องบุตรกับทรัพย์สิน",
      "บิดามารดาที่ต้องการจัดเรื่องอำนาจปกครองหรือค่าอุปการะเลี้ยงดูบุตร",
      "ผู้ที่ต้องรับรองบุตรหรือดำเนินเรื่องรับบุตรบุญธรรม",
    ],
    compare: {
      heading: "หย่าโดยความยินยอม กับ หย่าโดยคำพิพากษา",
      intro:
        "ถ้าตกลงกันได้ทุกประเด็น การหย่าที่สำนักทะเบียนจะเรียบง่ายกว่ามาก แต่ถ้ายังตกลงเรื่องบุตรหรือทรัพย์สินไม่ได้ ต้องเข้าสู่กระบวนการทางศาล",
      columns: ["หย่าโดยความยินยอม", "หย่าโดยคำพิพากษา"],
      rows: [
        {
          label: "เงื่อนไขตั้งต้น",
          cells: ["ทั้งสองฝ่ายยินยอมและมาลงนามได้", "ฝ่ายหนึ่งไม่ยินยอม หรือมีเหตุหย่าตามกฎหมาย"],
        },
        {
          label: "สถานที่ดำเนินการ",
          cells: ["สำนักทะเบียนที่รับจดทะเบียนหย่า", "ศาลที่มีเขตอำนาจ"],
        },
        {
          label: "เอกสารหลัก",
          cells: [
            "ทะเบียนสมรส บัตรประชาชนหรือหนังสือเดินทาง ทะเบียนบ้าน และบันทึกข้อตกลงการหย่า",
            "เอกสารเดียวกัน บวกพยานหลักฐานสนับสนุนเหตุหย่าและเอกสารเรื่องบุตรกับทรัพย์สิน",
          ],
        },
        {
          label: "ประเด็นบุตร",
          cells: ["ระบุในบันทึกข้อตกลงให้ชัดทั้งอำนาจปกครองและค่าอุปการะ", "ศาลพิจารณาโดยคำนึงถึงประโยชน์ของบุตรเป็นสำคัญ"],
        },
        {
          label: "ข้อควรระวัง",
          cells: [
            "บันทึกข้อตกลงที่เขียนกว้างเกินไปทำให้บังคับตามได้ยากภายหลัง",
            "ต้องเตรียมพยานให้ตรงประเด็นเหตุหย่า และเผื่อเวลาสำหรับหลายนัด",
          ],
        },
      ],
      note: "หากคู่สมรสเป็นชาวต่างชาติ ควรตรวจล่วงหน้าว่าประเทศต้นทางต้องใช้เอกสารรับรองรูปแบบใดเพื่อให้การหย่ามีผลที่นั่นด้วย",
    },
    faqs: [
      {
        question: "จดทะเบียนสมรสกับชาวต่างชาติในไทยต้องเตรียมอะไร",
        answer:
          "โดยทั่วไปฝ่ายต่างชาติต้องมีหนังสือรับรองสถานภาพการสมรสจากสถานทูตหรือหน่วยงานของประเทศตน แปลเป็นภาษาไทยพร้อมรับรองคำแปลและผ่านนิติกรณ์ ส่วนฝ่ายไทยใช้บัตรประชาชนและทะเบียนบ้าน รายละเอียดต่างกันตามสัญชาติ",
      },
      {
        question: "สัญญาก่อนสมรสทำได้จริงไหมในไทย",
        answer:
          "ทำได้ แต่ต้องทำก่อนจดทะเบียนสมรสและจดแจ้งพร้อมการจดทะเบียนสมรสตามที่กฎหมายกำหนด เนื้อหาต้องไม่ขัดต่อกฎหมายหรือความสงบเรียบร้อย จึงควรให้ทนายความร่างและตรวจก่อนวันจด",
      },
      {
        question: "ทรัพย์สินที่มีก่อนสมรสถือเป็นของใคร",
        answer:
          "ทรัพย์สินที่มีอยู่ก่อนสมรสโดยหลักเป็นสินส่วนตัว ส่วนที่ได้มาระหว่างสมรสมักเป็นสินสมรส ปัญหาที่พบบ่อยคือการนำเงินสินส่วนตัวไปปนกับสินสมรสจนแยกไม่ออก จึงควรเก็บหลักฐานการได้มาไว้",
      },
      {
        question: "หย่าแล้วบุตรอยู่กับใคร",
        answer:
          "หากตกลงกันได้ให้ระบุในบันทึกข้อตกลงให้ชัดทั้งผู้ใช้อำนาจปกครอง การติดต่อเยี่ยม และค่าอุปการะ หากตกลงไม่ได้ ศาลจะพิจารณาโดยคำนึงถึงประโยชน์ของบุตรเป็นสำคัญ",
      },
      {
        question: "ค่าอุปการะเลี้ยงดูบุตรกำหนดจากอะไร",
        answer:
          "พิจารณาจากความจำเป็นของบุตรและความสามารถของผู้มีหน้าที่ชำระ ควรระบุจำนวน วันชำระ ช่องทางชำระ และเงื่อนไขการปรับในอนาคตให้ชัด เพื่อให้บังคับได้เมื่อมีการผิดนัด",
      },
      {
        question: "บิดาที่ไม่ได้จดทะเบียนสมรสมีสิทธิในบุตรไหม",
        answer:
          "ต้องดำเนินการรับรองบุตรก่อน จึงจะมีสิทธิและหน้าที่ตามกฎหมายอย่างครบถ้วน การรับรองบุตรทำได้ทั้งทางทะเบียนเมื่อมีความยินยอมครบ หรือโดยคำพิพากษาเมื่อมีข้อโต้แย้ง",
      },
      {
        question: "ทะเบียนสมรสไทยใช้ที่ต่างประเทศได้ไหม",
        answer:
          "โดยทั่วไปต้องนำไปแปลและผ่านการรับรองตามที่ประเทศนั้นกำหนด บางประเทศรับเอกสารที่ผ่านนิติกรณ์ บางประเทศรับรูปแบบตามอนุสัญญาที่ตนเป็นภาคี ควรตรวจกับหน่วยงานผู้รับก่อนดำเนินการ",
      },
      {
        question: "เปลี่ยนนามสกุลหลังสมรสต้องทำอะไร",
        answer:
          "เป็นสิทธิที่เลือกได้ หากเลือกเปลี่ยนต้องแก้ไขเอกสารทะเบียนราษฎรและเอกสารประจำตัวให้สอดคล้องกัน รวมถึงเอกสารที่ใช้กับธนาคารและหน่วยงานอื่น เพื่อไม่ให้ชื่อไม่ตรงกันในภายหลัง",
      },
      {
        question: "หย่าในต่างประเทศแล้วต้องทำอะไรในไทย",
        answer:
          "ต้องนำคำพิพากษาหรือเอกสารการหย่ามาแปลและรับรองตามช่องทางที่กำหนด แล้วดำเนินการให้สถานะทางทะเบียนในไทยสอดคล้องกัน มิฉะนั้นสถานะในทะเบียนไทยจะยังเป็นสมรสอยู่",
      },
      {
        question: "รับบุตรบุญธรรมใช้เวลานานไหม",
        answer:
          "มีขั้นตอนตรวจสอบคุณสมบัติและความเหมาะสมของผู้ขอรับ ซึ่งใช้เวลาและมีเอกสารหลายชุด กรณีผู้ขอรับเป็นชาวต่างชาติจะมีขั้นตอนเพิ่มตามหลักเกณฑ์ที่เกี่ยวข้อง ทีมงานจะสรุปลำดับขั้นให้ตามกรณี",
      },
      {
        question: "คู่สมรสอยู่ต่างประเทศ ทำเรื่องแทนได้ไหม",
        answer:
          "บางขั้นตอนทำแทนได้ด้วยหนังสือมอบอำนาจที่รับรองถูกต้อง แต่บางขั้นตอน เช่น การลงนามในทะเบียน ต้องมาด้วยตนเอง ทีมงานจะแยกให้ชัดว่าขั้นไหนต้องมาเองและขั้นไหนมอบอำนาจได้",
      },
      {
        question: "ปรึกษาเรื่องครอบครัวข้อมูลจะถูกเก็บเป็นความลับไหม",
        answer:
          "ทนายความมีหน้าที่รักษาความลับของลูกความ เอกสารและข้อเท็จจริงที่ท่านให้จะใช้เพื่อดำเนินงานในเรื่องของท่านเท่านั้น ท่านนำเอกสารเท่าที่มีเข้ามาปรึกษาได้ก่อนตัดสินใจ",
      },
    ],
    related: ["estate", "notary-international", "property"],
    imageAlt: "ทนายความให้คำปรึกษาเรื่องครอบครัวและเอกสารทะเบียนกับผู้รับบริการที่โต๊ะประชุม",
  },

  estate: {
    answer:
      "งานมรดกของสำนักงานครอบคลุมการร่างพินัยกรรมให้รูปแบบครบถ้วน การยื่นคำร้องขอตั้งผู้จัดการมรดก การรวบรวมและโอนทรัพย์มรดกทั้งที่ดิน บัญชีเงินฝาก และหุ้น รวมถึงการจัดการข้อโต้แย้งระหว่างทายาท ทีมงานตรวจเอกสารทะเบียนราษฎรและเอกสารทรัพย์สินก่อนวางลำดับขั้นให้",
    seoTitle: "มรดกและพินัยกรรม — ผู้จัดการมรดกและโอนทรัพย์สิน",
    seoDesc:
      "ร่างพินัยกรรม ยื่นคำร้องตั้งผู้จัดการมรดก โอนที่ดินและบัญชีเงินฝากของผู้ตาย พร้อมรายการเอกสาร ขั้นตอนจริง ข้อควรระวัง และคำถามที่พบบ่อย",
    audience: [
      "ทายาทที่ธนาคารหรือสำนักงานที่ดินขอคำสั่งตั้งผู้จัดการมรดก",
      "ผู้ที่ต้องการทำพินัยกรรมไว้ล่วงหน้าให้ครอบครัวไม่ต้องมีข้อพิพาท",
      "ครอบครัวที่มีทรัพย์สินหลายประเภทและหลายจังหวัด",
      "ทายาทที่อยู่ต่างประเทศและต้องมอบอำนาจให้ดำเนินการ",
      "กรณีที่ทายาทมีความเห็นไม่ตรงกันเรื่องการแบ่งทรัพย์",
    ],
    compare: {
      heading: "มีพินัยกรรม กับ ไม่มีพินัยกรรม — ต่างกันที่ขั้นตอน",
      intro:
        "การมีพินัยกรรมไม่ได้ตัดขั้นตอนศาลออกทั้งหมดในทุกกรณี แต่ช่วยลดข้อโต้แย้งเรื่องเจตนาและทำให้ลำดับงานชัดขึ้นมาก",
      columns: ["มีพินัยกรรมที่ถูกต้อง", "ไม่มีพินัยกรรม"],
      rows: [
        {
          label: "ผู้มีสิทธิรับทรัพย์",
          cells: ["ตามที่ระบุในพินัยกรรม เท่าที่ไม่ขัดกฎหมาย", "ตามลำดับทายาทโดยธรรมที่กฎหมายกำหนด"],
        },
        {
          label: "ผู้จัดการมรดก",
          cells: ["มักระบุตัวไว้แล้ว ทำให้ยื่นคำร้องง่ายขึ้น", "ทายาทต้องตกลงกันว่าจะให้ใครยื่นคำร้อง"],
        },
        {
          label: "ความเสี่ยงเกิดข้อพิพาท",
          cells: ["ต่ำกว่า หากพินัยกรรมทำครบรูปแบบและชัดเจน", "สูงกว่า เพราะต้องตีความเจตนาและตกลงกันเอง"],
        },
        {
          label: "เอกสารที่ต้องเตรียม",
          cells: [
            "พินัยกรรมต้นฉบับ ใบมรณบัตร ทะเบียนบ้าน เอกสารทรัพย์สิน",
            "ใบมรณบัตร เอกสารแสดงความเป็นทายาททุกคน ทะเบียนบ้าน เอกสารทรัพย์สิน",
          ],
        },
        {
          label: "ข้อผิดพลาดที่พบบ่อย",
          cells: [
            "ทำพินัยกรรมไม่ครบรูปแบบ หรือระบุทรัพย์ไม่ตรงกับเอกสารสิทธิ",
            "โอนหรือถอนทรัพย์ก่อนมีคำสั่งศาล ทำให้เกิดข้อโต้แย้งภายหลัง",
          ],
        },
      ],
      note: "รายการทรัพย์ควรตรงกับเอกสารสิทธิจริง เช่น เลขโฉนดและเลขบัญชี เพื่อลดปัญหาตอนโอน",
    },
    faqs: [
      {
        question: "ทำไมธนาคารขอคำสั่งตั้งผู้จัดการมรดก",
        answer:
          "เพราะเมื่อเจ้าของบัญชีเสียชีวิต ธนาคารต้องมีหลักฐานว่าใครมีอำนาจจัดการทรัพย์ตามกฎหมาย คำสั่งศาลตั้งผู้จัดการมรดกคือเอกสารที่ใช้ยืนยันอำนาจนั้น เช่นเดียวกับการโอนที่ดินที่สำนักงานที่ดินขอเอกสารนี้",
      },
      {
        question: "ใครยื่นคำร้องขอตั้งผู้จัดการมรดกได้",
        answer:
          "โดยทั่วไปเป็นทายาท ผู้มีส่วนได้เสีย หรือผู้ที่พินัยกรรมระบุไว้ ในทางปฏิบัติควรให้ทายาททุกคนทราบและให้ความยินยอมเพื่อลดโอกาสคัดค้านและทำให้กระบวนการเร็วขึ้น",
      },
      {
        question: "ต้องเตรียมเอกสารอะไรบ้าง",
        answer:
          "โดยทั่วไปต้องมีใบมรณบัตร ทะเบียนบ้านของผู้ตายและทายาท เอกสารแสดงความเป็นทายาท บัญชีทรัพย์สินพร้อมสำเนาโฉนดหรือหลักฐานบัญชี พินัยกรรมหากมี และหนังสือให้ความยินยอมของทายาท",
      },
      {
        question: "ทายาทอยู่ต่างประเทศต้องกลับไทยไหม",
        answer:
          "หลายกรณีไม่ต้องกลับ ใช้หนังสือให้ความยินยอมหรือหนังสือมอบอำนาจที่ทำและรับรองที่ต่างประเทศแล้วนำมาแปลรับรองในไทย ทีมงานจะระบุรูปแบบเอกสารที่ต้องใช้ตามประเทศที่ท่านอยู่",
      },
      {
        question: "พินัยกรรมทำเองได้ไหม",
        answer:
          "ทำได้ แต่มีรูปแบบตามกฎหมายหลายแบบและแต่ละแบบมีเงื่อนไขเรื่องพยานและการลงนาม ข้อผิดพลาดเรื่องรูปแบบเป็นเหตุให้พินัยกรรมถูกโต้แย้งได้ จึงควรให้ทนายความตรวจก่อนลงนาม",
      },
      {
        question: "พินัยกรรมตัดทายาทได้หรือไม่",
        answer:
          "การกำหนดผู้รับทรัพย์ทำได้ในขอบเขตที่กฎหมายอนุญาต แต่มีข้อจำกัดบางประการเกี่ยวกับสิทธิของทายาท จึงควรให้ทนายความตรวจถ้อยคำเพื่อลดโอกาสถูกโต้แย้งในภายหลัง",
      },
      {
        question: "ที่ดินอยู่หลายจังหวัดต้องยื่นหลายที่ไหม",
        answer:
          "คำร้องขอตั้งผู้จัดการมรดกยื่นที่ศาลที่มีเขตอำนาจตามภูมิลำเนาของผู้ตายเป็นหลัก ส่วนการจดทะเบียนโอนต้องไปดำเนินการที่สำนักงานที่ดินซึ่งที่ดินแต่ละแปลงตั้งอยู่",
      },
      {
        question: "ผู้ตายมีหนี้ ทายาทต้องรับผิดเท่าไร",
        answer:
          "โดยหลักทายาทรับผิดไม่เกินทรัพย์มรดกที่ตกได้แก่ตน แต่การนำทรัพย์มรดกไปใช้ก่อนจัดการหนี้ให้ถูกต้องอาจทำให้เกิดปัญหา จึงควรทำบัญชีทรัพย์และหนี้ให้ชัดก่อนแบ่ง",
      },
      {
        question: "ระหว่างรอคำสั่งศาล ถอนเงินจากบัญชีผู้ตายได้ไหม",
        answer:
          "ไม่ควร เพราะยังไม่มีผู้มีอำนาจจัดการตามกฎหมาย การถอนหรือโอนทรัพย์ก่อนมีคำสั่งมักกลายเป็นประเด็นข้อพิพาทระหว่างทายาทและทำให้กระบวนการยืดออกไป",
      },
      {
        question: "ทายาทคัดค้านจะเป็นอย่างไร",
        answer:
          "เรื่องจะกลายเป็นคดีที่มีข้อโต้แย้งและต้องสืบพยาน ใช้เวลามากกว่ากรณีที่ทุกคนยินยอม ทางที่ประหยัดเวลาที่สุดคือเจรจาให้ได้ข้อตกลงเป็นลายลักษณ์อักษรก่อนยื่น",
      },
      {
        question: "ผู้จัดการมรดกมีหน้าที่อะไร",
        answer:
          "รวบรวมทรัพย์สินและหนี้สิน จัดทำบัญชีทรัพย์มรดก ชำระหนี้ที่ต้องชำระ และแบ่งทรัพย์ให้ทายาทตามสิทธิ โดยต้องจัดการด้วยความซื่อสัตย์และรายงานได้ว่าทรัพย์ถูกจัดการอย่างไร",
      },
      {
        question: "อยากให้สำนักงานดูแลทั้งเรื่องได้ไหม",
        answer:
          "ได้ ทีมงานรับดูแลตั้งแต่ตรวจเอกสาร ร่างคำร้อง ยื่นต่อศาล ประสานทายาท ไปจนถึงโอนที่ดินและปิดบัญชีธนาคารหลังได้คำสั่ง นำเอกสารเท่าที่มีเข้ามาปรึกษาได้ก่อน",
      },
    ],
    related: ["family", "property", "tax"],
    imageAlt: "ทนายความอธิบายเอกสารมรดกและพินัยกรรมให้ทายาทสองรุ่นที่โต๊ะประชุมสำนักงาน",
  },

  property: {
    answer:
      "งานที่ดินและอสังหาริมทรัพย์ของสำนักงานครอบคลุมการตรวจสอบเอกสารสิทธิและภาระผูกพันก่อนซื้อ ร่างและตรวจสัญญาจะซื้อจะขายหรือสัญญาเช่า จดทะเบียนสิทธิและนิติกรรมที่สำนักงานที่ดิน งานสิทธิเก็บกิน ภาระจำยอม การจำนอง รวมถึงข้อพิพาทเรื่องแนวเขตและการครอบครอง",
    seoTitle: "ที่ดินและอสังหาริมทรัพย์ — ตรวจโฉนด สัญญา และโอนกรรมสิทธิ์",
    seoDesc:
      "ตรวจเอกสารสิทธิและภาระผูกพัน ร่างสัญญาซื้อขายและเช่า จดทะเบียนนิติกรรมที่สำนักงานที่ดิน ภาระจำยอม จำนอง และข้อพิพาทแนวเขต พร้อมขั้นตอนจริง",
    audience: [
      "ผู้ซื้อที่ต้องการตรวจโฉนดและภาระผูกพันก่อนวางเงิน",
      "ผู้ขายที่ต้องเตรียมเอกสารและเงื่อนไขสัญญาให้รัดกุม",
      "ผู้ให้เช่าหรือผู้เช่าระยะยาวที่ต้องจดทะเบียนการเช่า",
      "ชาวต่างชาติที่ต้องเข้าใจข้อจำกัดการถือครองที่ดินและห้องชุด",
      "เจ้าของที่ดินที่มีปัญหาแนวเขต ทางเข้าออก หรือการครอบครองปรปักษ์",
    ],
    compare: {
      heading: "ซื้อที่ดิน เช่าระยะยาว หรือถือห้องชุด — ข้อพิจารณาต่างกัน",
      intro:
        "แต่ละทางมีเอกสารและข้อจำกัดต่างกัน โดยเฉพาะเมื่อผู้ถือสิทธิเป็นชาวต่างชาติ ตารางนี้สรุปประเด็นที่ต้องตรวจก่อนตัดสินใจ",
      columns: ["ซื้อที่ดินพร้อมสิ่งปลูกสร้าง", "เช่าระยะยาวและจดทะเบียนการเช่า", "ซื้อห้องชุด"],
      rows: [
        {
          label: "เอกสารสิทธิที่ต้องตรวจ",
          cells: ["โฉนดหรือเอกสารสิทธิอื่น ระวางและแนวเขต", "เอกสารสิทธิของผู้ให้เช่าและอำนาจให้เช่า", "หนังสือกรรมสิทธิ์ห้องชุดและเอกสารนิติบุคคลอาคารชุด"],
        },
        {
          label: "ภาระผูกพันที่พบบ่อย",
          cells: ["จำนอง ภาระจำยอม ทางจำเป็น การรอนสิทธิ", "สิทธิของผู้เช่าเดิม เงื่อนไขบอกเลิก", "หนี้ค่าส่วนกลางค้างชำระ ข้อบังคับนิติบุคคล"],
        },
        {
          label: "การจดทะเบียน",
          cells: ["จดทะเบียนโอนที่สำนักงานที่ดิน", "การเช่าที่มีกำหนดยาวต้องจดทะเบียนจึงใช้ยันบุคคลภายนอกได้", "จดทะเบียนโอนพร้อมหนังสือปลอดหนี้จากนิติบุคคล"],
        },
        {
          label: "ข้อพิจารณาสำหรับชาวต่างชาติ",
          cells: ["มีข้อจำกัดการถือครองที่ดินโดยตรง", "เป็นทางเลือกที่ใช้กันมากแต่ต้องอ่านเงื่อนไขต่ออายุให้ชัด", "ถือได้ตามเงื่อนไขและสัดส่วนที่กฎหมายกำหนดในอาคารชุดนั้น"],
        },
        {
          label: "จุดเสี่ยงตอนวางเงิน",
          cells: [
            "วางมัดจำก่อนตรวจเอกสารสิทธิ",
            "ทำสัญญาเช่าซ้อนหลายฉบับโดยไม่จดทะเบียน",
            "ไม่ตรวจหนี้ค่าส่วนกลางและสถานะนิติบุคคลก่อนโอน",
          ],
        },
      ],
      note: "ควรตรวจเอกสารสิทธิที่สำนักงานที่ดินก่อนวางเงินทุกกรณี และให้เงื่อนไขในสัญญาสอดคล้องกับผลการตรวจ",
    },
    faqs: [
      {
        question: "ก่อนวางมัดจำควรตรวจอะไรก่อน",
        answer:
          "ตรวจว่าผู้ขายเป็นผู้มีชื่อในเอกสารสิทธิจริง มีภาระผูกพันหรือจำนองอยู่หรือไม่ แนวเขตตรงกับที่ดูจริงหรือไม่ มีทางเข้าออกตามกฎหมายหรือไม่ และมีข้อจำกัดการใช้ประโยชน์ที่ดินในพื้นที่นั้นหรือไม่",
      },
      {
        question: "ตรวจโฉนดที่ไหนได้",
        answer:
          "ตรวจได้ที่สำนักงานที่ดินที่ที่ดินตั้งอยู่ ซึ่งจะเห็นรายการจดทะเบียนย้อนหลังและภาระผูกพันที่ปรากฏในสารบบ การดูเฉพาะสำเนาโฉนดที่ผู้ขายส่งมาไม่เพียงพอ",
      },
      {
        question: "สัญญาจะซื้อจะขายควรมีอะไรเป็นอย่างน้อย",
        answer:
          "ควรมีตัวทรัพย์ที่ระบุตรงกับเอกสารสิทธิ ราคาและงวดชำระ วันโอน ผู้รับภาระค่าธรรมเนียมและภาษีแต่ละรายการ เงื่อนไขบังคับก่อนโอน เช่น ปลอดจำนอง และผลเมื่อฝ่ายใดผิดสัญญา",
      },
      {
        question: "ชาวต่างชาติซื้อที่ดินในไทยได้ไหม",
        answer:
          "การถือครองที่ดินโดยตรงมีข้อจำกัดตามกฎหมาย ทางที่ใช้กันคือการถือห้องชุดตามเงื่อนไขที่กำหนด หรือการเช่าระยะยาวที่จดทะเบียน ควรตรวจโครงสร้างให้ถูกต้องแต่ต้น ไม่ใช้วิธีถือแทนซึ่งมีความเสี่ยง",
      },
      {
        question: "เช่าระยะยาวต้องจดทะเบียนหรือไม่",
        answer:
          "การเช่าที่มีกำหนดเวลายาวควรจดทะเบียนต่อพนักงานเจ้าหน้าที่ เพื่อให้ใช้ยันบุคคลภายนอกได้เมื่อทรัพย์เปลี่ยนมือ หากไม่จดทะเบียน สิทธิของผู้เช่าอาจถูกจำกัดกว่าที่คาดไว้",
      },
      {
        question: "ภาระจำยอมกับทางจำเป็นต่างกันอย่างไร",
        answer:
          "ภาระจำยอมเกิดจากการตกลงหรือเงื่อนไขตามกฎหมายและมักจดทะเบียนไว้ ส่วนทางจำเป็นเป็นสิทธิใช้ทางผ่านที่ดินผู้อื่นเมื่อที่ดินไม่มีทางออกสู่ทางสาธารณะ ทั้งสองเรื่องควรตรวจก่อนซื้อที่ดินตาบอด",
      },
      {
        question: "โอนที่ดินมีค่าใช้จ่ายอะไรบ้าง",
        answer:
          "โดยทั่วไปมีค่าธรรมเนียมการจดทะเบียน ภาษีและค่าอากรตามกรณี ซึ่งขึ้นกับราคาประเมิน ระยะเวลาถือครอง และสถานะของผู้ขาย ควรตกลงในสัญญาให้ชัดว่าฝ่ายใดรับภาระรายการใด",
      },
      {
        question: "ซื้อบ้านที่ยังติดจำนองได้ไหม",
        answer:
          "ทำได้ แต่ต้องกำหนดในสัญญาให้ชัดว่าจะไถ่ถอนจำนองเมื่อใดและด้วยเงินส่วนใด โดยปกติจะจัดให้การไถ่ถอนและการโอนเกิดขึ้นในวันเดียวกันที่สำนักงานที่ดินเพื่อลดความเสี่ยงของผู้ซื้อ",
      },
      {
        question: "ครอบครองปรปักษ์คืออะไร ควรระวังอย่างไร",
        answer:
          "คือกรณีที่ผู้อื่นครอบครองที่ดินของเราอย่างเปิดเผยและต่อเนื่องตามเงื่อนไขที่กฎหมายกำหนดจนอาจได้สิทธิ เจ้าของที่ดินที่ปล่อยที่ว่างไว้นานควรตรวจสภาพจริงและเอกสารเป็นระยะ",
      },
      {
        question: "แนวเขตไม่ตรงกับเพื่อนบ้านต้องทำอย่างไร",
        answer:
          "เริ่มจากขอรุกวัดหรือสอบเขตกับสำนักงานที่ดินเพื่อให้มีข้อเท็จจริงทางเอกสาร แล้วจึงเจรจาบนผลการวัด หากยังตกลงไม่ได้จึงพิจารณาดำเนินคดีโดยใช้ผลการสอบเขตเป็นพยานหลักฐาน",
      },
      {
        question: "มอบอำนาจให้คนอื่นไปโอนแทนได้ไหม",
        answer:
          "ได้ แต่หนังสือมอบอำนาจต้องทำตามแบบและระบุขอบเขตอำนาจให้ชัด หากผู้มอบอำนาจอยู่ต่างประเทศมักต้องมีการรับรองลายมือชื่อและนิติกรณ์ก่อนนำมาใช้ในไทย",
      },
      {
        question: "ให้สำนักงานไปดำเนินการที่สำนักงานที่ดินแทนได้ไหม",
        answer:
          "ได้ ทีมงานรับตรวจเอกสารสิทธิ ร่างสัญญา จัดเตรียมเอกสารของทั้งสองฝ่าย และเข้าดำเนินการจดทะเบียนที่สำนักงานที่ดินตามนัด พร้อมประสานเรื่องเอกสารต่างประเทศหากคู่สัญญาเป็นชาวต่างชาติ",
      },
    ],
    related: ["estate", "corporate", "litigation"],
    imageAlt: "ทนายความตรวจเอกสารสิทธิที่ดินร่วมกับผู้รับบริการที่โต๊ะประชุมสำนักงานกฎหมาย",
  },
};
